import {
  Header,
  HeaderBrand,
  HeaderContent,
  HeaderRightZone,
  Headers
} from "design-react-kit";
import React from "react";
import logo from "../../logo.svg";
interface HeaderProps {
  tagLine: string;
  title: string;
  preTitle: string;
}

const CustomHeader: React.FC<HeaderProps> = ({ tagLine, title, preTitle }) => {
  return (
    <Headers>
      <Header type="slim" theme="">
        <HeaderContent>
          <HeaderBrand href="https://piao.dfp.gov.it/" iconName={logo}>
            {preTitle}
          </HeaderBrand>
        </HeaderContent>
      </Header>
      <div className="it-nav-wrapper">
        <Header theme="" type="center">
          <HeaderContent>
            <HeaderBrand href="https://piao.dfp.gov.it/" iconName={logo}>
              <h2>{title}</h2>
              <h3>{tagLine}</h3>
            </HeaderBrand>
            <HeaderRightZone>
              {/* <HeaderSocialsZone label="Seguici su">
            <ul>
              <li>
                <a aria-label="Facebook" href="#" target="_blank">
                  <Icon icon="it-facebook" />
                </a>
              </li>
              <li>
                <a aria-label="Github" href="#" target="_blank">
                  <Icon icon="it-github" />
                </a>
              </li>
              <li>
                <a aria-label="Twitter" href="#" target="_blank">
                  <Icon icon="it-twitter" />
                </a>
              </li>
            </ul>
          </HeaderSocialsZone> */}

            </HeaderRightZone>
          </HeaderContent>
        </Header>
        <Header type="slim" theme="dark" style={{ backgroundColor: "#0065cc" }} />
      </div>
    </Headers>
  );

};

export default CustomHeader;
